exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-modal[data-v-68ce87ec]{height:100%;width:100%;background:rgba(0,0,0,.5);position:fixed;z-index:9999;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}.modal-content[data-v-68ce87ec]{background:#fff;padding:20px;border-radius:8px;position:relative;width:80%;max-width:700px}.close-button[data-v-68ce87ec]{position:absolute;top:10px;right:10px;background:transparent;border:none;font-size:24px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68ce87ec","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/dashboard/LicenseInfoModal.vue
// module id = Wb+0
// module chunks = 32 101